var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9766 9.5C37.5607 22.3273 24.9393 33.4874 17.7476 37.7446C17.4421 37.9255 17.0612 37.7023 17.0612 37.3473V33.1242C17.0612 32.9025 16.8991 32.7109 16.6822 32.6649C4.74894 30.1384 2.50009 22.9405 2.34288 19.006C1.85282 6.74088 11.6645 2.32545 17.0612 2.32544C24.4024 2.32542 28.1777 6.88344 29.9766 9.5Z",
    stroke: "white",
    strokeWidth: 4.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6591 18.3624L20.6592 18.3625L20.6636 18.3575L21.8566 17.0319C22.6761 16.1435 23.1971 14.9045 23.1971 13.5449L23.1971 13.5434C23.1811 10.1727 20.6569 7.39717 17.4972 7.39717C14.791 7.39717 12.5464 9.43784 11.962 12.1292C11.7505 13.1031 12.5827 13.8534 13.4776 13.8534C14.413 13.8534 15.0673 13.073 15.3935 12.3645C15.7852 11.5135 16.5851 10.9503 17.4972 10.9503C18.7791 10.9503 19.852 12.0737 19.852 13.5284C19.852 14.2408 19.578 14.8938 19.155 15.3674L17.4881 17.1898C17.488 17.1899 17.4878 17.1901 17.4877 17.1903C16.7713 17.9665 16.2492 18.9555 16.0013 20.0539C15.7747 21.0581 16.6353 21.8327 17.5585 21.8327C18.5287 21.8327 19.2021 21.0397 19.3799 20.1865C19.5169 19.5286 19.7734 19.2685 20.2579 18.7771C20.3773 18.656 20.5105 18.521 20.6591 18.3624ZM19.277 26.0914V25.8489C19.277 24.866 18.4802 24.0692 17.4972 24.0692C16.5143 24.0692 15.7175 24.866 15.7175 25.8489V26.0914C15.7175 27.0743 16.5143 27.8711 17.4972 27.8711C18.4802 27.8711 19.277 27.0743 19.277 26.0914Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support_icon.51932282e93382a57a3798e670bf3c7d.svg";
export { ForwardRef as ReactComponent };